import { Link } from "react-router-dom";
import { ROUTES } from "@/app/routes";
import { SEO } from "@/components/seo/SEO";
import { Button } from "@/components/ui/Button";
import { CyberPanel } from "@/components/ui/CyberPanel";

export function NotFound() {
  return (
    <main className="cyber-grid grid min-h-screen place-items-center bg-ink px-4 text-content-primary">
      <SEO title="Page Not Found" description="The requested Kalaco page could not be found." robotsIndex={false} robotsFollow={false} />
      <CyberPanel className="max-w-xl text-center">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.28em] text-teal-200">404</p>
        <h1 className="text-4xl font-bold uppercase text-white sm:text-5xl">Page Not Found</h1>
        <p className="mt-4 text-content-secondary">The page may have moved, or the link may be incorrect.</p>
        <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
          <Button asChild>
            <Link to={ROUTES.home}>Return Home</Link>
          </Button>
          <Button asChild variant="secondary">
            <Link to={ROUTES.contact}>Contact</Link>
          </Button>
        </div>
      </CyberPanel>
    </main>
  );
}
